module.exports = __webpack_public_path__ + "media/images/icon__infoBox@3x-7ee50309958bf0ec56cbe70b4c516a68.png";